var guardConstants = {

	/**
	 * Return value indicating unsaved changes were detected.  This value
	 * may be returned by both okToRun and conditionallyRun.
	 */
	UNSAVED_CHANGES_DETECTED: false,

	/**
	 * Return value indicating unsaved changes were not detected, so it is
	 * OK to proceed. This value may be returned by both okToRun and
	 * conditionallyRun.
	 */
	UNSAVED_CHANGES_NOT_DETECTED: true,

	/**
	 * Return value indicating that the unsaved changes warning dialog
	 * should be hidden. This is a valid return value for a
	 * keepChangesFunction (see the guard method for an explanation),
	 * continueFunction (see the Warning constructor for an
	 * explanation), or yesFunction (see Warning constructor)
	 */
	HIDE_WARNING: false

}

export default guardConstants

guardConstants.__filename__ = 'components/unsaved/guard-constants.js'
